import { getUserManager, useReactOidc } from '@axa-fr/react-oidc-context';

const runtimeConfig = window.runConfig;
const isLocalhost = ['127.0.0.1', 'localhost'].includes(window.location.hostname);
const baseDomain = isLocalhost
    ? runtimeConfig.REACT_APP_OIDC_LOCAL_ORIGIN
    : `https://${runtimeConfig.REACT_APP_SIGN}`;

export const oidcConfiguration = {
    authority: `${runtimeConfig.REACT_APP_KC_URL}/realms/${runtimeConfig.REACT_APP_KC_REALM}`,
    client_id: runtimeConfig.REACT_APP_KC_CLIENT_ID,
    redirect_uri: `${baseDomain}/authentication/callback`,
    silent_redirect_uri: `${baseDomain}/authentication/silent_callback`,
    post_logout_redirect_uri: baseDomain,
    response_type: 'code',
    scope: 'openid profile email roles',
    automaticSilentRenew: true,
    loadUserInfo: false,
};

export const useOidc = () => {
    const { oidcUser, login, logout, isLoading } = useReactOidc();

    return {
        oidcUser,
        isAuthenticated: Boolean(oidcUser),
        isLoading,
        login,
        logout,
    };
};

let refreshPromise = null;

export const refreshOidcToken = async () => {
    if (!refreshPromise) {
        const userManager = getUserManager();
        if (!userManager) return null;
        refreshPromise = userManager
            .signinSilent()
            .then((user) => user?.access_token || null)
            .catch((err) => {
                console.warn('OIDC silent renew failed:', err);
                return null;
            })
            .finally(() => {
                refreshPromise = null;
            });
    }
    return refreshPromise;
};

export const getOidcAccessToken = async () => {
    const userManager = getUserManager();
    if (!userManager) return '';
    const user = await userManager.getUser();
    if (user && !user.expired) {
        return user.access_token || '';
    }
    if (user && user.expired) {
        const refreshedToken = await refreshOidcToken();
        if (refreshedToken) return refreshedToken;
    }
    return user?.access_token || '';
};

let isLoggingOut = false;

export const logoutOidc = async () => {
    if (isLoggingOut) return;

    isLoggingOut = true;
    const userManager = getUserManager();
    const user = await userManager?.getUser();
    await userManager?.removeUser();

    const params = new URLSearchParams({
        post_logout_redirect_uri: oidcConfiguration.post_logout_redirect_uri,
        client_id: oidcConfiguration.client_id,
    });

    if (user?.id_token) params.set('id_token_hint', user.id_token);

    window.location.assign(`${oidcConfiguration.authority}/protocol/openid-connect/logout?${params.toString()}`);
};